/**
 * 提现订单状态
 */
export enum WithdrawOrderStatus {
    Default = '',
    Initial = 0, // 待受理
    Processing = 10, // 受理中
    Success = 11, // 打款成功
    Fail = 12, // 打款失败
    Cancel = -1, // 取消
}

/**
 * @description 渠道
 */
export enum ChannelType {
    OY = 'OY',
    OFFLINE = 'OFFLINE',
}
export const ChannelType_Names = Object.freeze({
    [ChannelType.OY]: 'withdraw.channel.oy',
    [ChannelType.OFFLINE]: 'withdraw.channel.offline',
});
